import sliceCreator from '../../index.jsx';
import {LOGIN_WITH_OTP} from '../../../constants/index.jsx';
const _loginWithOTPAction = sliceCreator('LOGIN_WITH_OTP', LOGIN_WITH_OTP, 'post');

const { asyncAction: loginWithOTPAction, reducer, clearData: clearLoginWithOTPAction } = _loginWithOTPAction;

export default reducer;

export {
    loginWithOTPAction,
    clearLoginWithOTPAction
}